import { useQuery } from "@apollo/client/react";
import { Stack } from "@mui/material";
import { ContentSkeleton } from "../lib/closet";
import Link from "../lib/Link";
import Screen from "../lib/Screen";
import ScreenSection from "../lib/ScreenSection";
import { GetLifetimeAccountsReportDocument } from "./GetLifetimeAccountsReport.generated";
import { Widget, WidgetRow, WidgetRowLayout } from "./Widget";

export default function ReportsScreen() {
  const { data, error } = useQuery(GetLifetimeAccountsReportDocument, {
    fetchPolicy: "cache-and-network",
  });

  if (error) throw error;
  if (!data) return <ContentSkeleton />;

  return (
    <Screen title="Reports" maxWidth="md">
      <Stack spacing={2}>
        <WidgetRow layout={WidgetRowLayout.HALF}>
          <Widget title="Residents" value={data.reports.totalInmates} />
          <Widget title="Visitors" value={data.reports.totalVisitors} />
        </WidgetRow>
      </Stack>

      <ScreenSection title="Index">
        <Stack spacing={2}>
          <Link to="/toolbox/reports/accounts">Active users</Link>
          <Link to={"/toolbox/reports/call-ratings"}>Call ratings</Link>
          <Link to={"/toolbox/reports/system-satisfaction"}>
            System satisfaction
          </Link>
        </Stack>
      </ScreenSection>
    </Screen>
  );
}
